import { Radio, Select, Spin, Switch, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { pagedSystems } from "@/services/rd/system/api";
import { history, useModel } from "@@/exports";
import { setUserSystemCache } from "@/services/common/api";
import { BulbFilled } from "@ant-design/icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { useEmotionCss } from "@ant-design/use-emotion-css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import {
  buildGroupedSystemSelectOptions,
  filterGroupedSystemSelectOption,
  type SystemListItemForGroup,
} from "@/utils/systemGroupedSelectOptions";

/** 与导航栏搭配：固定宽度，下拉与触发器同宽，搜索框随下拉变宽，避免「框很窄、列表很宽」 */
const SYSTEM_SELECT_WIDTH = 150;

const SystemSelect: React.FC = () => {
  const [checked, setChecked] = useState(true);
  const [defaultSystem, setDefaultSystem] = useState('');
  const { initialState, setInitialState } = useModel('@@initialState');

  const groupedOptions = useMemo(
    () => buildGroupedSystemSelectOptions(initialState?.systemList as SystemListItemForGroup[] | undefined),
    [initialState?.systemList],
  );

  const selectedSystemLabel = useMemo(() => {
    const list = initialState?.systemList as SystemListItemForGroup[] | undefined;
    const id = defaultSystem;
    const found = list?.find((s) => s.systemId === id);
    return found?.systemName ?? id ?? "";
  }, [initialState?.systemList, defaultSystem]);

  // const {  run } = useRequest((id)=>{(id)}, { manual: true })





  const changeSystem = async (val: string) => {
    //清除bug的当前模块
    localStorage.setItem('testbugModule', 'all')
    localStorage.setItem('prodbugModule', 'all')
    const { resultCode, resultObject } = await setUserSystemCache(val);
    if (resultCode === 'success') {
      setDefaultSystem(val)
      setInitialState((preInitialState) => ({
        ...preInitialState,
        defaultSystem: resultObject
      }));
      // window.location.reload();
    }

  }


  const onChange = (checked: boolean) => {
    let settings = {
      ...initialState?.settings
    }
    if (checked) {
      settings.navTheme = 'light'
    } else {
      settings.navTheme = 'realDark'
    }
    setChecked(checked)
    localStorage.setItem('navTheme', settings.navTheme);
    setInitialState((preInitialState) => ({
      ...preInitialState,
      settings
    }));
  };

  useEffect(() => {
    const defaultSystemId = initialState?.defaultSystem?.systemDTO?.systemId || '';
    // console.log(defaultSystemId)
    if (!defaultSystemId && (initialState?.systemList?.length ?? 0) > 0) {
      changeSystem(initialState?.systemList[0].systemId)
    } else {
      setDefaultSystem(defaultSystemId)
    }

    if (!localStorage.getItem('navTheme') || localStorage.getItem('navTheme') === 'light') {
      setChecked(true)
    } else {
      setChecked(false)
    }
  }, [defaultSystem])



  return (
    <>
      <span
        className="app-system-select-wrap"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, lineHeight: 1 }}
      >
        <span
          style={{
            color: 'rgba(0, 0, 0, 0.45)',
            fontSize: 12,
            whiteSpace: 'nowrap',
            userSelect: 'none',
            flexShrink: 0,
          }}
        >
          系统
        </span>
        <Select
          style={{ width: SYSTEM_SELECT_WIDTH }}
          popupMatchSelectWidth
          value={defaultSystem.toString()}
          size="small"
          showSearch
          filterOption={filterGroupedSystemSelectOption}
          optionFilterProp="label"
          placeholder="请选择或搜索系统"
          onSelect={changeSystem}
          options={groupedOptions}
          optionRender={(option) => (
            <span title={String(option.label ?? "")}>{option.label}</span>
          )}
        />
      </span>
      {/* <Tooltip title={'主题颜色'}>
        <Switch defaultChecked onChange={onChange} checked={checked} size={'small'} style={{ borderRadius: 10, paddingBlock: 0, paddingInline: 0 }}
          checkedChildren={<FontAwesomeIcon icon={faSun} />}
          unCheckedChildren={<FontAwesomeIcon icon={faMoon} />}
        />
      </Tooltip> */}
    </>
  );
};

export default SystemSelect;
